import { branding } from "./utils";

export class Name {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Name";
    this.scene = "Name";
    this.data = [];
    this.page = 7101;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = branding({
        game: options.game,
        team: options.team,
        xml,
        presToggle: options.presToggle,
        kit: options.kit,
      });

      xml.payload.field.find((item) => {
        return item.attr.name === "102"; // Number
      }).value = options.player.first_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "103"; // Number
      }).value = options.player.last_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "200"; // Number
      }).value = options.subtext || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "100"; // Number
      }).value = options.team?.variables?.badge || "";

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
